import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';


@Pipe({
  name: 'safeHtml',
  standalone: true
})
export class SafeHtmlPipe implements PipeTransform {

  constructor(protected sanitizer: DomSanitizer) { }

  public transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    const domParser = new DOMParser();
    const docElement = domParser.parseFromString(value, "text/html").documentElement;
    const emCollection = docElement.getElementsByTagName("a");

    for (var i = 0; i < emCollection.length; i++) {
      let urljs = "<a href=\"#\" onclick=\"window.open('" + emCollection[i].href + "', '_system', 'location=yes'); return false;\">" + emCollection[i].textContent + "</a>";

      value = value ? value.replace(String(emCollection[i].outerHTML), urljs) : 'Não Informado';
    }

    switch (type) {
      case 'html':
      case 'htmlSemTratarLink':
        return this.sanitizer.bypassSecurityTrustHtml(value);
      case 'layout':
        return this.sanitizer.bypassSecurityTrustHtml(value.replace(/\n/g, '<br>'));
      case 'style':
        return this.sanitizer.bypassSecurityTrustStyle(value);
      case 'script':
        return this.sanitizer.bypassSecurityTrustScript(value);
      case 'url':
        return this.sanitizer.bypassSecurityTrustUrl(value);
      case 'resourceUrl':
        return this.sanitizer.bypassSecurityTrustResourceUrl(value);
      default:
        return this.sanitizer.bypassSecurityTrustHtml('Não Informado');
    }
  }
}
